import React, {useState, useEffect} from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import InputGroup from 'react-bootstrap/InputGroup';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import LineItem from "../purchaseorders/line_items";

function CutListForm() {
  const [LineItemID, setLineItemID] = useState(2);
  const [LineItems, setLineItems] = useState([
    {
      id: LineItemID - 1,
      room: '',
      flooring_type: '',
      flooring: '',
      length: '',
      width: ''
    }
  ])

  const handleFormChange = (event, index) => {
    let data = [...LineItems];
    data[index][event.target.name] = event.target.value;
    setLineItems(data);
  }

  const submit = (e) => {
    e.preventDefault();
    console.log(LineItems)
  }

  const AddLineItems = () => {

    setLineItemID(LineItemID + 1)

    let object = {
      id: LineItemID,
      room: '',
      flooring_type: '',
      flooring: '',
      length: '',
      width: ''
    }
    setLineItems([...LineItems, object])
  }

  const [Property, SetProperty] = useState([
    {
      id: '',
      name: '',
      address: '',
      parish: '',
      postcode: ''
    }
  ]);

  const SelectProperty = async () => {
    var property = document.getElementById('Property_Select');
    var property_id = property.options[property.selectedIndex].value;
    SetProperty(property_id);
    fetchRooms(property_id);
    console.log(property_id)
  }

  const SelectRoom = () => {
    var selected_room = document.getElementById('Room_Select');
    var room = selected_room.options[selected_room.selectedIndex].value;
    var test = Rooms.find(r => r.id == room);
  }

  const SelectFlooring = async () => {
    var flooring = document.getElementById('Flooring_Select');
    var flooring_id = flooring.options[flooring.selectedIndex].value;
    setFlooring(flooring_id);
    console.log(flooring_id)
  }

  // Get Properties
  const [Properties, setProperties] = useState([
    {
      id: '',
      name: '',
      address: '',
      parish: '',
      postcode: ''
    }
  ])
  const fetchData = async () => {
    try {
      const response = await fetch('http://127.0.0.1:3000/properties.json');
      const data = await response.json(JSON.parse)
      setProperties(data);
    }
    catch (err) {
      console.log(err)
    }
  }

  // Get Rooms
  const [Rooms, setRooms] = useState([
    {
      id: '',
      name: '',
      length: '',
      width: '',
      size: ''
    }
  ])

  const fetchRooms = async (property_id) => {
    try {
      const response = await fetch('http://127.0.0.1:3000/properties/' + property_id + '/rooms.json');
      const data = await response.json(JSON.parse)
      console.log(data)
      setRooms(data);
    }
    catch (err) {
      console.log(err)
    }
  }

   // Get Flooring
   const [Flooring, setFlooring] = useState([])

  const fetchFlooring = async (flooring_id) => {
    try {
      const response = await fetch('http://127.0.0.1:3000/products.json');
      const data = await response.json(JSON.parse)
      console.log(data)
      setFlooring(data);
    }
    catch (err) {
      console.log(err)
    }
  }

  const Calculate_Flooring_Size = async (lineitem_id, room) => {
    console.log("I want to calculate the sizes")

  }

  const [FilteredFlooring, SetFilteredFlooring] = useState([]);
  const SetFlooringType = () => {
    var SelectFlooringType = document.getElementById('FlooringType_Select');
    var SelectFlooringID = SelectFlooringType.options[SelectFlooringType.selectedIndex].value;
    SetFilteredFlooring(Flooring.filter(p => p.product_type == SelectFlooringID ));
  }

  useEffect(() => {
    fetchData(),
    fetchFlooring()
  }, [])

  const StockCheck = async (check) => {
    switch(check) {
      case 1:
            <Button className="btn btn-success">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-plus-circle" viewBox="0 0 16 16">
                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                <path d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z"/>
              </svg>
            </Button>
      case 2:
            <Button className="btn btn-danger">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-plus-circle" viewBox="0 0 16 16">
                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
              </svg>
            </Button>
      };
    return check;
  }


  return (
    <Container fluid="py-1">
      <Form onSubmit={submit}>
        <Form.Select
          property='property'
          onChange={SelectProperty}
          id="Property_Select"
        >
        <option>Select a Property</option>
        {Properties.map(fbb =>
          <option key={fbb.id} value={fbb.id}>{fbb.name + " " + fbb.address + " " + fbb.parish + " " + fbb.postcode}</option>
        )};

        </Form.Select>
        {LineItems.map((form, index) => {
          return (
              <div key={index}>
                <Row className="m-3">
                  <InputGroup>
                    <Col className="p-1 col-auto">
                      <Button onClick={AddLineItems}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-plus-circle" viewBox="0 0 16 16">
                          <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                          <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                        </svg>
                      </Button>
                    </Col>
                    <Col className="p-1 col-1">
                      <Form.Control
                        type="id"
                        value={"#" + form.id}
                        readOnly
                      />
                    </Col>
                    <Col className="p-1 col-auto">
                      <Form.Select
                        room='room'
                        placeholder='Select A Room'
                        id="Room_Select"
                        onChange={SelectRoom}
                      >
                      <option>Select a Room</option>
                      {Rooms.map(fbb =>
                        <option key={fbb.id} value={fbb.id}>{fbb.name}</option>
                      )};
                      </Form.Select>
                    </Col>
                    <Col className="p-1 col-auto">
                      <Form.Select
                          flooring_type="flooring_type"
                          id="FlooringType_Select"
                          aria-describedby="flooring_typeHelpBlock"
                          onChange={SetFlooringType}
                        >
                        <option>Select a Flooring Type</option>
                        <option value="Carpet">Carpets</option>
                        <option value="Vinyl">Vinyls</option>
                        <option value="Pack">Packs</option>
                      </Form.Select>
                    </Col>
                    <Col className="p-1 col-auto">
                      <Form.Select
                        flooring='flooring'
                        placeholder='Select Flooring'
                        id="Flooring_Select"
                      >
                      <option>Select a Flooring</option>
                      {FilteredFlooring.map(fbb =>
                        <option key={fbb.id} value={fbb.id}>{fbb.name}</option>
                      )};
                      </Form.Select>
                    </Col>
                    <Col className="p-1 col-2">
                      <Form.Control
                        length='length'
                        placeholder='Length'
                        value={form.length}
                        readOnly
                      />
                    </Col>
                    <Col className="p-1 col-2">
                      <Form.Control
                        width='width'
                        placeholder='Width'
                        value={form.width}
                        readOnly
                      />
                    </Col>
                    <Col className="p-1 col-auto">

                    </Col>
                  </InputGroup>
                </Row>
              </div>
          )})}
      </Form>
    </Container>
  );
}

export default CutListForm;
